"use strict";

var _$spread_24 = function (callback) {
  return function (arr) {
    return callback.apply(null, arr);
  };
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNwcmVhZC5qcyJdLCJuYW1lcyI6WyJtb2R1bGUiLCJjYWxsYmFjayIsImFyciIsImFwcGx5Il0sIm1hcHBpbmdzIjoiQUFBQSxZQUFBLENBQUE7O0FBc0JBQSxlQUFBQSxHQUFpQixVQUFnQkMsUUFBaEIsRUFBZ0JBO0VBQy9CLE9BQU8sVUFBY0MsR0FBZCxFQUFjQTtJQUNuQixPQUFPRCxRQUFBQSxDQUFTRSxLQUFURixDQUFlLElBQWZBLEVBQXFCQyxHQUFyQkQsQ0FBUCxDQUFBO0dBREYsQ0FBQTtDQURGRCxDQUFBQSIsInNvdXJjZXNDb250ZW50IjpbbnVsbF19